"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSentryErrorReporter = exports.generateID = exports.validateParams = exports.isParamsEmpty = exports.parseAndSendRedirectParams = exports.handleRedirectPage = exports.parseHash = exports.getLoginHandler = exports.ArcanaException = void 0;
var types_1 = require("./types");
var oauth_1 = require("./oauth");
var Sentry = __importStar(require("@sentry/browser"));
var logger_1 = require("./logger");
var ArcanaException = /** @class */ (function (_super) {
    __extends(ArcanaException, _super);
    function ArcanaException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ArcanaException;
}(Error));
exports.ArcanaException = ArcanaException;
function getLoginHandler(loginType, appID) {
    switch (loginType) {
        case types_1.LoginType.google: {
            return new oauth_1.GoogleHandler(appID);
        }
        case types_1.LoginType.twitch: {
            return new oauth_1.TwitchHandler(appID);
        }
        case types_1.LoginType.discord: {
            return new oauth_1.DiscordHandler(appID);
        }
        case types_1.LoginType.reddit: {
            return new oauth_1.RedditHandler(appID);
        }
        case types_1.LoginType.github: {
            return new oauth_1.GithubHandler(appID);
        }
        case types_1.LoginType.twitter: {
            return new oauth_1.TwitterHandler(appID);
        }
    }
}
exports.getLoginHandler = getLoginHandler;
var parseHash = function (url) {
    var _a;
    var params = {};
    var queryParams = url.searchParams;
    var hashParams = new URLSearchParams(url.hash.substring(1));
    for (var key in RedirectParamsList) {
        var val = hashParams.get(key);
        if (!val) {
            val = queryParams.get(key);
        }
        if (val) {
            params = __assign(__assign({}, params), (_a = {}, _a[key] = val, _a));
        }
    }
    return params;
};
exports.parseHash = parseHash;
var RedirectParamsList;
(function (RedirectParamsList) {
    RedirectParamsList["state"] = "state";
    RedirectParamsList["access_token"] = "access_token";
    RedirectParamsList["error"] = "error";
    RedirectParamsList["error_uri"] = "error_uri";
    RedirectParamsList["error_description"] = "error_description";
    RedirectParamsList["id_token"] = "id_token";
    RedirectParamsList["token_type"] = "token_type";
    RedirectParamsList["scope"] = "scope";
    RedirectParamsList["expires_in"] = "expires_in";
    RedirectParamsList["code"] = "code";
    RedirectParamsList["oauth_token"] = "oauth_token";
    RedirectParamsList["oauth_token_secret"] = "oauth_token_secret";
    RedirectParamsList["oauth_verifier"] = "oauth_verifier";
})(RedirectParamsList || (RedirectParamsList = {}));
var handleRedirectPage = function (origin) {
    if (origin === void 0) { origin = '*'; }
    try {
        (0, exports.parseAndSendRedirectParams)(window.location, origin);
    }
    catch (error) {
        var logger = (0, logger_1.getLogger)('handleRedirectPage');
        logger.error('could not parse and send redirect params', { error: error });
    }
};
exports.handleRedirectPage = handleRedirectPage;
var parseAndSendRedirectParams = function (location, origin) {
    var _a;
    var params = (0, exports.parseHash)(new URL(location.href));
    var returnParams = { status: 'success', params: params };
    if ((0, exports.isParamsEmpty)(returnParams.params)) {
        returnParams.status = 'error';
        returnParams.error = 'paramater list is empty';
    }
    else if (params.error) {
        returnParams.status = 'error';
        returnParams.error = params.error;
    }
    (_a = window.opener) === null || _a === void 0 ? void 0 : _a.postMessage(returnParams, origin);
    return;
};
exports.parseAndSendRedirectParams = parseAndSendRedirectParams;
var isParamsEmpty = function (params) {
    return Object.keys(params).length === 0;
};
exports.isParamsEmpty = isParamsEmpty;
var validateParams = function (params, state) {
    if (params.error) {
        var e = new Error(params.error_description);
        e.name = params.error;
        return e;
    }
    if (params.state && params.state !== state) {
        var e = new Error('State did not match');
        e.name = 'StateMismatch';
        return e;
    }
    return null;
};
exports.validateParams = validateParams;
var generateID = function () {
    return ('_' +
        Math.random()
            .toString(36)
            .substr(2, 9));
};
exports.generateID = generateID;
var getSentryErrorReporter = function () {
    Sentry.init({
        dsn: 'https://d36bd0cc31cb46feb91a0c39e9b5178a@o1011868.ingest.sentry.io/6005958',
        maxBreadcrumbs: 5,
        debug: true,
    });
    return function (msg) {
        Sentry.captureMessage(msg);
    };
};
exports.getSentryErrorReporter = getSentryErrorReporter;
